/**
 * Monetary formatting helpers.
 *
 * Critical Decision (launch-pricing plan): all monetary values shown to users
 * with **max 2 decimal places** (e.g. $0.39, never $0.328).
 */

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const USD_FORMATTER_NO_DECIMALS = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export function formatUsdFromCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return '$0.00'
  return USD_FORMATTER.format(cents / 100)
}

export function formatUsd(dollars: number | null | undefined): string {
  if (dollars === null || dollars === undefined || Number.isNaN(dollars)) return '$0.00'
  return USD_FORMATTER.format(dollars)
}

/** Round a per-credit overage rate (in cents) to 2-decimal display, e.g. 33 -> "$0.33". */
export function formatOverageRatePerCredit(centsPerCredit: number): string {
  return formatUsdFromCents(centsPerCredit)
}
